import * as tslib_1 from "tslib";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { noop } from 'lodash';
import Popover from "../../core/Popover";
import Button from '../Button';
import "./ButtonWithDropdown.css";

var ButtonWithDropdown =
/** @class */
function (_super) {
  tslib_1.__extends(ButtonWithDropdown, _super);

  function ButtonWithDropdown() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      isPopoverOpen: false
    };

    _this.togglePopover = function () {
      var isPopoverOpen = _this.state.isPopoverOpen;

      _this.setState({
        isPopoverOpen: !isPopoverOpen
      });
    };

    _this.closePopover = function () {
      _this.setState({
        isPopoverOpen: false
      });
    };

    _this.handleCaretClick = function (e) {
      _this.togglePopover(e);

      _this.props.onCaretClick(e);
    };

    return _this;
  }

  ButtonWithDropdown.prototype.render = function () {
    var _a = this.props,
        dropdown = _a.dropdown,
        className = _a.className,
        onClick = _a.onClick,
        children = _a.children,
        popoverClassName = _a.popoverClassName,
        onCaretClick = _a.onCaretClick,
        // eslint-disable-line no-unused-vars
    other = tslib_1.__rest(_a, ["dropdown", "className", "onClick", "children", "popoverClassName", "onCaretClick"]);

    var isPopoverOpen = this.state.isPopoverOpen;
    var popoverBody = React.cloneElement(dropdown, {
      togglePopover: this.togglePopover
    });
    var baseClassName = 'nx-button-with-dropdown';
    return React.createElement(Button, tslib_1.__assign({}, other, {
      component: "div",
      className: cx(baseClassName, baseClassName + "__container", className)
    }), React.createElement("div", {
      className: baseClassName + "__btn",
      onClick: onClick
    }, children), React.createElement("div", {
      className: baseClassName + "__divider"
    }), React.createElement(Popover, {
      className: cx(baseClassName + "__popover", popoverClassName),
      body: popoverBody,
      arrow: false,
      isOpen: isPopoverOpen,
      onClickOutside: this.closePopover,
      popper: {
        placement: 'bottom-end',
        modifiers: {
          offset: {
            offset: '0px, 1px'
          }
        }
      }
    }, React.createElement("div", {
      className: baseClassName + "__caret",
      onClick: this.handleCaretClick
    }, React.createElement("i", {
      className: "icon-custom-caret-down-light"
    }))));
  };

  ButtonWithDropdown.propTypes = {
    dropdown: PropTypes.node.isRequired,
    className: PropTypes.string,
    popoverClassName: PropTypes.string,
    onClick: PropTypes.func,
    onCaretClick: PropTypes.func,
    children: PropTypes.node
  };
  ButtonWithDropdown.defaultProps = {
    onClick: noop,
    onCaretClick: noop
  };
  return ButtonWithDropdown;
}(Component);

export default ButtonWithDropdown;

try {
  // @ts-ignore
  ButtonWithDropdown.__docgenInfo = {
    "description": "",
    "displayName": "ButtonWithDropdown",
    "props": {}
  };
} catch (__react_docgen_typescript_loader_error) {}